<template>
  <section id="roomRules" class="bg-primary-dark">
    <div class="container pt90 pb90">
      <h6 class="section-subtitle text-center text-white-gray">The Puppy Lounge Doesn't Have Many Rules</h6>
      <!--Added rulesHead from previous Version-->
      <h3 class="section-title mb70 text-white" id="rulesHead" contenteditable="false">We pretty much only have FOUR
        rules:</h3>
      <div class="row">
        <div class="col-md-10 mr-auto ml-auto">
          <div class="carousel-review owl-carousel owl-theme">
            <div class="item text-center">
              <!--Added rulesBody from previous Version-->
              <p class="text-white-gray" id="rulesBody" contenteditable="false">
                <b>1. Don't skip, whatever you do just live with your mistakes.</b></p>
            </div>
            <div class="item text-center">
              <!--Added rulesBody from previous Version-->
              <p class="text-white-gray" id="rulesBody" contenteditable="false">
                <b>2. Go with the flow, do your best to follow the vibe.</b></p>
            </div>
            <div class="item text-center">
              <!--Added rulesBody from previous Version-->
              <p class="text-white-gray" id="rulesBody" contenteditable="false">
                <b>3. If you are following rule 2 you should know that you probably can't throw in any country.<br>
                  So don't play that.</b></p>
            </div>
            <div class="item text-center">
              <!--Added rulesBody from previous Version-->
              <p class="text-white-gray" id="rulesBody" contenteditable="false">
                <b>4. Now, If you play a clean Version of a song you will automatically get a nope
                  <br>from one of our admins <br>@MF Dave.</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'rules-section',
  props: {

  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>

<style lang="scss">

</style>
